import React from 'react';
import { Chip, makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';

const useStyles = makeStyles(theme => ({
  chip: {
    marginLeft: theme.spacing(1),
    fontSize: '11px',
    fontWeight: 'bold',
    color: 'white'
  },
  caseNote: {
    backgroundColor: theme.palette.success.main
  }
}));

const NoteStatus = ({
  hasCaseNotes,
  hasInternalNotes,
  hasManagementNotes,
  hasOnHoldNotes,
  hasPhysicalTechNotes
}) => {
  const classes = useStyles();
  const classNames = [classes.chip];

  let count = 0;
  let title = '';
  if (hasCaseNotes) {
    title = 'C. Notes';
    count += 1;
    classNames.push(classes.caseNote);
  }
  if (hasInternalNotes) {
    title = 'I. Notes';
    count += 1;
  }
  // backward compatibility
  if (!hasCaseNotes && hasManagementNotes) {
    title = 'D. T. Notes';
    count += 1;
  }
  if (hasPhysicalTechNotes) {
    title = 'P. T. Notes';
    count += 1;
  }
  if (hasOnHoldNotes) {
    title = 'H. Notes';
    count += 1;
  }
  if (count > 1) {
    title = 'M. Notes';
  }

  return count ? (
    <Chip color="primary" size="small" className={classNames.join(' ')} label={title} />
  ) : null;
};

NoteStatus.propTypes = {
  hasCaseNotes: PropTypes.bool.isRequired,
  hasInternalNotes: PropTypes.bool.isRequired,
  hasManagementNotes: PropTypes.bool.isRequired,
  hasPhysicalTechNotes: PropTypes.bool.isRequired,
  hasOnHoldNotes: PropTypes.bool.isRequired
};

export default NoteStatus;
